import { owcTheme } from 'core/theme/theme.config';
import { PocSelectDropdown } from 'commons/components/components-wrapper/poc-select-dropdown.component';
import styled from 'styled-components';

export const QcSelectDropdownStyled = styled(PocSelectDropdown)`
    max-width: 200px;

    owc-base-dropdown {
        max-width: 200px;
    }
`;

export const DeviceConfigStatusChipInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    padding: 0.5rem;
    background: ${owcTheme['one-color-background-brand-lowest']};
    border-radius: ${owcTheme['one-border-radius-8']};
`;
